import { differenceInYears, endOfISOWeek, format, getISOWeek, getISOWeekYear, intlFormatDistance, isSameMonth, isSameYear, parseISO, startOfISOWeek, } from "date-fns";
import { dateFnsLocale } from "./locale";
/*
 * Every function here is pure: `now` is a parameter, never `new Date()`, so
 * a test pins time the way aggregates do.
 */
/**
 * A `calendarDay` (`YYYY-MM-DD`) as LOCAL midnight. `new Date("2026-09-19")`
 * is UTC midnight, which is the 18th in Brazil (UTC−3); `parseISO` of a
 * date-only string is local.
 */
export function parseCalendarDay(day) {
    return parseISO(day);
}
/** The local calendar day of a date as `YYYY-MM-DD`. */
export function toCalendarDay(date) {
    return format(date, "yyyy-MM-dd");
}
/**
 * The day-of-month pattern, and the day alone, per locale: US English puts
 * the month first, German writes the day as an ordinal ("12. Sept."), and
 * every other locale the app ships writes "12 set" (`D267`).
 */
function dayPatterns(locale) {
    if (locale === "en-US") {
        return { day: "d", dayMonth: "MMM d" };
    }
    if (locale === "de-DE") {
        return { day: "d.", dayMonth: "d. MMM" };
    }
    return { day: "d", dayMonth: "d MMM" };
}
/** "12 set" / "Sep 12". */
export function formatDay(date, locale) {
    return format(date, dayPatterns(locale).dayMonth, {
        locale: dateFnsLocale(locale),
    });
}
/**
 * "hoje", "ontem", "há 3 dias" / "today", "yesterday", "3 days ago" — and
 * "amanhã" / "tomorrow" forward. Counted in local CALENDAR days, so a DST
 * night (23 or 25 hours) is still one day.
 */
export function formatRelativeDay(date, now, locale) {
    return intlFormatDistance(date, now, {
        locale,
        numeric: "auto",
        unit: "day",
    });
}
/** The ISO (Monday-start) week that contains `date`. */
export function weekRange(date, locale) {
    const start = startOfISOWeek(date);
    const end = endOfISOWeek(date);
    const options = { locale: dateFnsLocale(locale) };
    let label;
    if (isSameMonth(start, end) && isSameYear(start, end)) {
        label =
            locale === "en-US"
                ? `${format(start, "MMM d", options)}–${format(end, "d", options)}`
                : `${format(start, dayPatterns(locale).day, options)}–${format(end, dayPatterns(locale).dayMonth, options)}`;
    }
    else {
        label = `${formatDay(start, locale)} – ${formatDay(end, locale)}`;
    }
    return { end, label, start };
}
/** "2026-W37" — the key `GET /me/retrospective?week=` takes. */
export function isoWeekKey(date) {
    const week = String(getISOWeek(date)).padStart(2, "0");
    return `${getISOWeekYear(date)}-W${week}`;
}
/** Whole years from `birthDate` to `now`. Replaces A2's `ageOf`. */
export function ageFrom(birthDate, now) {
    return differenceInYears(now, birthDate);
}
//# sourceMappingURL=date.js.map